interface NewGamePlayerListProps {
  players: IUser[]
  hostEmail?: string
  isHost: boolean
  onRemoveBot?: (botId: string) => void
  removingBots?: Set<string>
}

const NewGamePlayerList: React.FC<NewGamePlayerListProps> = ({
  players,
  hostEmail,
  isHost,
  onRemoveBot,
  removingBots = new Set(),
}) => {
  return (
    <>
      <div className="text-white font-fourth text-lg whitespace-nowrap">
        Players
      </div>
      <div className="grid grid-cols-2 gap-3" data-testid="newgame.player-list">
        {players?.map((player) => (
          <div
            key={player?.email}
            className="bg-gradient-to-r from-[#1a1a1a] to-[#2a2a2a] border border-[#333] rounded-xl p-4 flex items-center justify-between shadow-lg backdrop-blur-sm"
          >
            <div className="text-white font-fourth text-lg flex items-center gap-3">
              <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
              {player?.username}
              {player?.bot && (
                <div className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-bold px-2 py-1 rounded-full text-xs">
                  Bot
                </div>
              )}
            </div>
            <div className="flex items-center gap-2">
              {player?.email === hostEmail && (
                <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-black font-bold px-3 py-1 rounded-full text-xs">
                  Host
                </div>
              )}
              {isHost &&
                player?.bot &&
                player?.email !== hostEmail &&
                onRemoveBot && (
                  <button
                    onClick={() => onRemoveBot(player.email)}
                    disabled={removingBots.has(player.email)}
                    className={`flex items-center gap-2 px-3 py-1 rounded-lg font-semibold text-xs transition-all duration-200 ${
                      removingBots.has(player.email)
                        ? "bg-gradient-to-r from-gray-600 to-gray-700 text-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-red-500 to-rose-500 hover:from-red-600 hover:to-rose-600 text-white hover:scale-105 active:scale-100"
                    }`}
                  >
                    <i className="fas fa-trash w-3 h-3"></i>
                    {removingBots.has(player.email) ? "Removing..." : "Remove"}
                  </button>
                )}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default NewGamePlayerList
